/** AWS regions, shared by anything that needs a region picker (job config, S3 buckets). */
export const AWS_REGIONS: { value: string; label: string }[] = [
  { value: 'us-east-1',      label: 'US East (N. Virginia)' },
  { value: 'us-east-2',      label: 'US East (Ohio)' },
  { value: 'us-west-1',      label: 'US West (N. California)' },
  { value: 'us-west-2',      label: 'US West (Oregon)' },
  { value: 'ca-central-1',   label: 'Canada (Central)' },
  { value: 'eu-west-1',      label: 'Europe (Ireland)' },
  { value: 'eu-west-2',      label: 'Europe (London)' },
  { value: 'eu-west-3',      label: 'Europe (Paris)' },
  { value: 'eu-central-1',   label: 'Europe (Frankfurt)' },
  { value: 'eu-north-1',     label: 'Europe (Stockholm)' },
  { value: 'eu-south-1',     label: 'Europe (Milan)' },
  { value: 'ap-southeast-1', label: 'Asia Pacific (Singapore)' },
  { value: 'ap-southeast-2', label: 'Asia Pacific (Sydney)' },
  { value: 'ap-northeast-1', label: 'Asia Pacific (Tokyo)' },
  { value: 'ap-northeast-2', label: 'Asia Pacific (Seoul)' },
  { value: 'ap-northeast-3', label: 'Asia Pacific (Osaka)' },
  { value: 'ap-south-1',     label: 'Asia Pacific (Mumbai)' },
  { value: 'sa-east-1',      label: 'South America (São Paulo)' },
  { value: 'me-south-1',     label: 'Middle East (Bahrain)' },
  { value: 'af-south-1',     label: 'Africa (Cape Town)' },
  { value: 'mx-central-1',     label: 'Mexico (Central)' },
];
